<div class='users-component' style='height: 100%'>
  <p-table [value]="users"
           [style]="{'margin-top':'10px'}"
           #table
           dataKey="emailAddress"
           [expandedRowKeys]="expanded"
  >
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;font-weight: bold">
        <th colspan="2">Email</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr class="ui-widget-header" *ngIf="rowGroupMetadata[item.emailAddress].index === rowIndex">
        <td colspan="2">
          <span>{{item.emailAddress}}</span>
        </td>
      </tr>
    </ng-template>


    <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td>{{item.tenantName}}</td>
        <td>
          <mat-checkbox [checked]="item.isMultiloginEnabled"
                        (change)="setMultilogin(item.userId, item.tenantName, $event.checked)"></mat-checkbox>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
